module.exports = __webpack_public_path__ + "static/media/ACIC.bfbd636b.webp";